import React from 'react';
import { CatalogueOperation } from 'pages/catalogues';
import { SaleType } from 'api/query/catalogue';
import { CreateProps } from './create-props';
import CreateCatalogueForm from '../create-catalogue-form';

/**
 * Create a new catalogue.
 * @param props
 */
export const Create: React.FC<CreateProps> = (props) => {
  const {
    type = SaleType.PrivateTreatySale, // Default to Sales
  } = props;

  return (
    <CreateCatalogueForm
      {...props}
      type={type}
      operation={CatalogueOperation.Create}
    />
  );
};

(Create as any).whyDidYouRender = {
  customName: 'Create',
};
